<template>
  <div class="good-stand-list">
    <div class="page-title">
      <span>{{title}}</span>
      <span v-if="total || total === 0" class="list-total">(共 <span class="list-total__num">{{total}}</span> 条记录)</span>
    </div>
    <pageTable
      :loading="loading"
      :col="col"
      :data="data"
      :total="total"
      :pageSize="pageSize"
      :pageIndex="pageIndex"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>

<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import { druglist } from '@/api/goodStand.js'
export default {
  name: 'goodstand',
  components: {
    pageTable
  },
  data() {
    return {
      loading: false,
      col: [],
      data: [],
      total: 0,
      pageSize: 30,
      pageIndex: 1,
      demosDrugCol: [
        { field: 'appr_num', title: '批准文号', width: 140 },
        { field: 'prod_name', title: '药品名称', width: 160 },
        { field: 'en_name', title: '英文名称', width: 160 },
        { field: 'comm_name', title: '商品名', width: 160 },
        { field: 'dosage_form', title: '剂型', width: 60 },
        { field: 'specification', title: '规格', width: 90 },
        { field: 'listed_holder', title: '上市许可持有人', width: 110 },
        { field: 'ent_name', title: '生产厂家', width: 200 },
        { field: 'ent_addr', title: '生产地址', width: 200 },
        { field: 'prod_class', title: '药品类别', width: 90 },
        { field: 'appr_time', title: '批准日期', width: 90 },
        { field: 'appr_num_o', title: '原批准文号', width: 140 },
        { field: 'std_code', title: '药品本位码', width: 140 }
      ],
      importDragCol: [
        { field: 'prd_name', title: '药品名称(中文)', width: 160 },
        { field: 'en_prd_name', title: '药品名称(英文)', width: 160 },
        { field: 'comm_name', title: '商品名(中文)', width: 160 },
        { field: 'en_comm_name', title: '商品名(英文)', width: 160 },
        { field: 'reg_num', title: '注册证号', width: 80 },
        { field: 'old_reg_num', title: '原注册证号', width: 100 },
        { field: 'reg_mark', title: '注册证号备注', width: 140 },
        { field: 'appr_num', title: '分包装批准文号', width: 140 },
        { field: 'com_name', title: '公司名称(中文)', width: 160 },
        { field: 'en_com_name', title: '公司名称(英文)', width: 160 },
        { field: 'address', title: '地址(中文)', width: 200 },
        { field: 'en_address', title: '地址(英文)', width: 200 },
        { field: 'region', title: '国家/地区(中文)', width: 200 },
        { field: 'en_region', title: '国家/地区(英文)', width: 200 },
        { field: 'dosage_form', title: '剂型(中文)', width: 100 },
        { field: 'specification', title: '规格(中文)', width: 100 },
        { field: 'pac_specification', title: '包装规格(中文)', width: 120 },
        { field: 'ent_nam', title: '生产厂家(中文)', width: 200 },
        { field: 'en_ent_name', title: '生产厂家(英文)', width: 200 },
        { field: 'ent_addr', title: '厂家地址(中文)', width: 200 },
        { field: 'en_ent_addr', title: '厂家地址(英文)', width: 200 },
        { field: 'ent_region', title: '厂家国家/地区(中文)', width: 150 },
        { field: 'en_ent_region', title: '厂家国家/地区(英文)', width: 150 },
        { field: 'lic_time', title: '发证日期', width: 100 },
        { field: 'expire_time', title: '有效期截止日', width: 100 },
        { field: 'pac_ent_name', title: '分包装企业名称', width: 160 },
        { field: 'pac_ent_addr ', title: '分包装企业地址', width: 200 },
        { field: 'pac_appr_time', title: '分包装文号批准日期', width: 150 },
        { field: 'pac_appr_expire', title: '分包装文号有效期截止日', width: 160 },
        { field: 'prd_type', title: '药品类别', width: 90 },
        { field: 'std_code', title: '药品本位码', width: 130 }
      ]
    }
  },
  computed: {
    title() {
      return this.$route.name === 'demosdrug' ? '国产药品情况' : '进口药品情况'
    },
    apiType() {
      return this.$route.name === 'demosdrug' ? 'guonei' : 'jinkou'
    }
  },
  watch: {
    '$route'() {
      this.pageIndex = 1
      this.pageSize = 30
      this.initCol()
      this.getData()
    }
  },
  mounted() {
    this.initCol()
    this.getData()
  },
  methods: {
    initCol() {
      const arr = this.$route.name === 'demosdrug' ? this.demosDrugCol : this.importDragCol
      const tmp = arr.map(col => {
        col.titleAlign = 'left'
        col.columnAlign = 'left'
        col.isResize = true
        col.formatter = function(rowData, rowIndex, pagingIndex, field) {
          if (rowData[field] === '') {
            return ''
          } else {
            return '<span title="' + rowData[field] + '">' + rowData[field] + '</span>'
          }
        }
        return col
      })
      this.col = tmp
    },
    getData() {
      this.loading = true
      druglist({
        type: this.apiType,
        params: {
          cp: this.pageIndex,
          rp: this.pageSize
        }
      }).then(res => {
        this.loading = false
        const { code, result } = res
        this.data = []
        this.total = 0
        if (code === 0) {
          this.data = result.list
          this.total = result.count * 1
        }
      })
    },
    pageChange(page) {
      this.pageIndex = page
      this.getData()
    },
    pageSizeChange(pageSize) {
      this.pageIndex = 1
      this.pageSize = pageSize
      this.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.good-stand-list {
  position: relative;
}
.list-total {
  color: $fontLightBlack;
  font-size: 12px;
  // font-family: PingFangSC-Regular;
  line-height: 12px;
  padding: 0 5px;
  &__num {
    color: $blue;
  }
}
</style>
